import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { AcreditacionEmpresaFormInput, AcreditacionEmpresaFormOutput } from '../acreditacion-empresa-form/acreditacion-empresa-form.interfaces';
import { Store, select } from '@ngrx/store';
import { EntityAcreditacionEmpresa } from '../../../../entity-acreditacion-empresa.model';
import { EntityAcreditacionEmpresaAddRequest, EntityAcreditacionEmpresaUpdateRequest } from '../../../../entity-acreditacion-empresa.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { EntityEtapasEmpresa } from '../../../../../entity-etapas-empresa/entity-etapas-empresa.model';
import { EntityEspeciesCertificables } from 'projects/registro-personas-empresas/src/app/features/actividades/entity-especies-certificables/entity-especies-certificables.model';
import { selectAllEntityEtapasEmpresa } from '../../../../../entity-etapas-empresa/entity-etapas-empresa.selectors';
import { State } from '../../../../../../../features/vista-usuario/vista-usuario.state';
import { selectAcreditacionEmpresaById, selectEntityAcreditacionEmpresaIsLoading } from '../../../../entity-acreditacion-empresa.selectors';
import { Subscription } from 'rxjs';
import { selectAllEntityEspeciesCertificables } from 'projects/registro-personas-empresas/src/app/features/actividades/entity-especies-certificables/entity-especies-certificables.selectors';
import { selectCurrentEmpresa } from '../../../../../entity-mis-empresas/entity-current-empresa.selectors';
import { FileUploaderImages } from 'projects/registro-personas-empresas/src/app/shared/file-uploader/file-uploader.interfaces';
import { FormActionType } from '@rpe/registro-personas-empresas-lib';

@Component({
  selector: 'rpe-acreditacion-empresa-form-container',
  templateUrl: './acreditacion-empresa-form-container.component.html',
  styleUrls: ['./acreditacion-empresa-form-container.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AcreditacionEmpresaFormContainerComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = []

  acreditacionEmpresaFormInput: AcreditacionEmpresaFormInput = {
    etapas: [],
    especiesCertificables: [],
  }

  formType: FormActionType

  acreditacionFormOutput: AcreditacionEmpresaFormOutput

  etapas: EntityEtapasEmpresa[] = []
  especiesCertificables: EntityEspeciesCertificables[] = []

  isLoading: boolean = false

  acreditacionEmpresaId: number
  empresaId: number

  constructor(
    private store: Store<State>,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
  ) {
    this.acreditacionEmpresaId = this.activatedRoute.snapshot.params.id

    if (this.acreditacionEmpresaId) {
      this.formType = FormActionType.Update
    }
  }

  ngOnInit(): void {
    const s1 = this.store.pipe(select(selectEntityAcreditacionEmpresaIsLoading)).subscribe(isLoading => {
      this.isLoading = isLoading
      this.cdr.detectChanges()
    })

    const s2 = this.store.pipe(select(selectCurrentEmpresa)).subscribe((empresa) => {
      this.empresaId = empresa.id
    })

    this.getEtapasEmpresa()
    this.getEspeciesCertificables()

    if (this.acreditacionEmpresaId) {
      this.getAcreditacionEmpresa()
    }

    this.subscriptions.push(s1, s2)
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe())
  }

  onFormChange(event: AcreditacionEmpresaFormOutput): void {
    this.acreditacionFormOutput = event
  }

  getAcreditacionEmpresa(): void {
    const s = this.store.pipe(
      select(selectAcreditacionEmpresaById(this.acreditacionEmpresaId))
    ).subscribe((acreditacionEmpresa) => {
      const files = this.createFiles(acreditacionEmpresa)

      this.acreditacionEmpresaFormInput = {
        ...this.acreditacionEmpresaFormInput,
        etapas_id: acreditacionEmpresa.etapas_id,
        especies_certificable_id: acreditacionEmpresa.especies_certificable_id,
        files: files
      }

      this.cdr.detectChanges()
    })

    this.subscriptions.push(s)
  }

  toAcreditacionEmpresa(): EntityAcreditacionEmpresa {
    let acreditacionEmpresa = this.acreditacionFormOutput

    let data = {
      entidad_productiva_id: this.empresaId,
      etapas_id: acreditacionEmpresa.etapas_id.map(etapa => etapa),
      especies_certificable_id: acreditacionEmpresa.especies_certificable_id.map(especie => especie),
      ...this.createManualesCalidad(this.acreditacionFormOutput.files)
    }

    return data as EntityAcreditacionEmpresa
  }

  onCancel(): void {
    this.router.navigateByUrl('/main/landing')
  }

  onConfirm(): void {
    if (this.formType != FormActionType.Update) {
      this.store.dispatch(EntityAcreditacionEmpresaAddRequest({ item: this.toAcreditacionEmpresa() }))
    } else {
      this.store.dispatch(EntityAcreditacionEmpresaUpdateRequest({ item: { ...this.toAcreditacionEmpresa(), id: this.acreditacionEmpresaId } }))
    }
  }

  createManualesCalidad(files: FileUploaderImages[]): EntityAcreditacionEmpresa {
    let data: EntityAcreditacionEmpresa = {} as EntityAcreditacionEmpresa

    for (let i = 0; i < files.length; i++) {
      (data as any)[('manual_calidad_' + (i + 1)) as any] = files[i]
    }

    return data
  }

  getEtapasEmpresa(): void {
    const s = this.store.pipe(select(selectAllEntityEtapasEmpresa)).subscribe(etapas => {
      this.etapas = etapas
      this.acreditacionEmpresaFormInput = { ...this.acreditacionEmpresaFormInput, etapas: this.etapas }
    })

    this.subscriptions.push(s)
  }

  getEspeciesCertificables(): void {
    const s = this.store.pipe(select(selectAllEntityEspeciesCertificables)).subscribe(especies => {
      this.especiesCertificables = especies
      this.acreditacionEmpresaFormInput = { ...this.acreditacionEmpresaFormInput, especiesCertificables: this.especiesCertificables }
    })

    this.subscriptions.push(s)
  }

  createFiles(acreditacionEmpresa: EntityAcreditacionEmpresa): FileUploaderImages[] {
    const files = [acreditacionEmpresa.manual_calidad_1]

    if (acreditacionEmpresa?.manual_calidad_2) {
      files.push(acreditacionEmpresa.manual_calidad_2)
    }

    if (acreditacionEmpresa?.manual_calidad_3) {
      files.push(acreditacionEmpresa.manual_calidad_3)
    }

    if (acreditacionEmpresa?.manual_calidad_4) {
      files.push(acreditacionEmpresa.manual_calidad_4)
    }

    if (acreditacionEmpresa?.manual_calidad_5) {
      files.push(acreditacionEmpresa.manual_calidad_5)
    }

    return this.createFileUploaderImages(files)
  }

  createFileUploaderImages(files: File[]): FileUploaderImages[] {
    return files.map((file) => {
      return {
        name: file.name,
        target: '',
        size: file.size,
        file: file
      }
    })
  }
}
